import React, { useEffect, useRef } from "react";
import FeaturesCarousel from "./FeaturesCarousel";

import image1 from "../../assets/online/TBM-1.jpg";
import image2 from "../../assets/online/TBM-2.jpg";
import image3 from "../../assets/online/TBM-4.jpg";
import { Link } from "@reach/router";

export default function LandingOnlineFeatures() {
  const containerRef = useRef(null);

  // Usamos IntersectionObserver para detectar la visibilidad
  useEffect(() => {
    const observerOptions = {
      root: null, // Usamos la ventana de visualización
      rootMargin: "0px",
      threshold: 0.3, // Al 10% del componente visible, se activa la animación
    };

    // Función para manejar la visibilidad del componente
    const handleIntersection = (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.remove("opacity-0");
          entry.target.classList.add("animate-fade-in");
        } 
      });
    };


    // Creamos el IntersectionObserver
    const observer = new IntersectionObserver(handleIntersection, observerOptions);

    // Observamos los componentes
    if (containerRef.current) observer.observe(containerRef.current);

    return () => {
      // Limpiamos el observer cuando el componente se desmonte
      if (containerRef.current) observer.unobserve(containerRef.current);
    };
  }, []);

  const features = [
    {
      title: "Clases en línea",
      description:
        "Entrena desde donde estés con nuestras Master Coaches. Accede a más de 800 clases y nuevos estrenos cada semana."},
    {
      title: "Workout Planner",
      description: "Organiza tus clases según tus objetivos, tus días de entrenamiento y el tipo de rutina que mejor se adapte a ti."},
    {
      title: "Lleva registro de tu progreso",
      description: "Da seguimiento a tus avances, mantén claridad sobre tus metas y reconoce cada paso de tu proceso."},
    {
      title: "Comunidad",
      description: "Comparte tus experiencias y mantente motivada. Conecta con una comunidad de mujeres que comparten el deseo de moverse, crecer y ser mejores."},
  ];

  const renderFeatures = () => {
    return features.map((feature, index) => (
      <div
        key={index}
        className={`features__content__feature d-flex ${
          index !== features.length - 1 ? "content__feature-border" : ""
        }`}
      >
        <i className="fas mt-1 fa-check-circle me-2 text-dark" aria-hidden />
        <span className="feature__desc text-dark">
          <b className="d-block">{feature.title}</b>
          {feature.description}
        </span>
      </div>
    ));
  };

  const imagesList = [
    image1,
    image2,
    image3,
  ]

  return (
    <div className="online__features opacity-0 mx-auto" style={{ maxWidth: "1100px"}} ref={containerRef}>
      <div className="features__content">
        <h6 className="online-subtitle text-dark mb-3">
          Tu bienestar, a un clic de distancia
        </h6>
        <h2 className="online-title text-dark">
          Una plataforma con las herramientas y disciplinas para transformar tu forma de entrenar
        </h2>
        {renderFeatures()}

        <Link to="/pages/workout-planner" className="btn bg-warning mt-4">
          Conoce tu plan ideal
        </Link>
      </div>

      <FeaturesCarousel options={{ loop: true }} slides={imagesList}/>
    </div>
  );
}
